module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"photovoltaic":"Photovoltaik","pvProduction":"PV-Produktion","ownUse":"Eigenverbrauch","measurementData":"Messdaten","reductionPaths":"Absenkpfade"}}')
  delete Component.options._Ctor
}
